import clsx from 'clsx';
import React, { ChangeEvent, useState } from 'react';
import { useForm } from '../../../../../../hooks/useForm';
import { SettingItemActions } from '../../../SettingItemActions';
import { Input } from '../../../../../../components/Input';
import { Label } from '../../../../../../components/Label';
import { SettingTag } from '../../../SettingTag';

interface Props {
  index: number;
  routingGroup: CreateRoutingGroup;
  onRemove?(index: number): void;
  onSave?(item: CreateRoutingGroup, index: number): void;
}

interface Content extends Props {
  editing: boolean;
}

interface Form extends Content {
  values: CreateRoutingGroup;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
  updateField(field: keyof CreateRoutingGroup, value: any): void;
}

export const RoutingGroup = (props: Props) => {
  const [editing, setEditing] = useState(false);
  const { index, onRemove = null, onSave = null, routingGroup } = props;
  const { values, onChange, updateField } = useForm<CreateRoutingGroup>(
    routingGroup,
    () => null
  );

  return (
    <div
      className={clsx(
        'w-full inline-flex items-center justify-between gap-4 h-14'
      )}
    >
      <EditCloudDvr
        editing={editing}
        onChange={onChange}
        updateField={updateField}
        values={values}
        {...props}
      />
      <CloudDvrContent editing={editing} {...props} />
      {onRemove && onSave ? (
        <SettingItemActions
          canSave={
            (values.description ?? '').trim() !== '' &&
            (values.mediafirstId ?? '').trim() !== ''
          }
          editing={editing}
          onEdit={() => setEditing(true)}
          onRemove={() => onRemove(index)}
          onSave={() => {
            onSave(values, index);
            setEditing(false);
          }}
          onCancel={() => setEditing(false)}
        />
      ) : null}
    </div>
  );
};

const EditCloudDvr = ({ editing, values, onChange }: Form) => {
  const defaultProps: any = {
    variant: 'contained',
    onChange: onChange,
    required: true,
  };

  if (editing === false) return null;
  return (
    <fieldset className="inline-flex items-center gap-4">
      <Input
        name="description"
        label="Description"
        value={values.description}
        {...defaultProps}
      />
      <Input
        name="mediafirstId"
        label="MediaFirst ID"
        value={values.mediafirstId}
        {...defaultProps}
      />
    </fieldset>
  );
};

const CloudDvrContent = ({ editing, routingGroup }: Content) => {
  if (editing) return null;

  return (
    <>
      <SettingTag name={routingGroup.description} color="violet" />
      <Label text="MediaFirst ID:" align="left">
        {routingGroup.mediafirstId}
      </Label>
    </>
  );
};
